<template>
  <div class="getCenterTrackMonth">
    <reportPageTemp
      ref="reportPageTemp"
      :reportParams="reportParams"
      :filter="filter"
    >
      <div class="flex-wrap">
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.coursetype_id"
              clearable
              filterable
              :placeholder="
                $t('views.Analysisreport.admTrackReport.51yzwntm4j40')
              "
              @change="search"
            >
              <el-option
                v-for="(item, index) in filterList.coursetypeList"
                :key="index"
                :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                :value="item.coursetype_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <!-- <div class="flex-al mb10 mr10">
          <div class="ipt-box" style="width: 280px">
            <el-input
              v-model="filter.keyword"
              clearable
              placeholder="可检索校区名称、区域名称"
              @clear="search"
              @keyup.enter.native="search"
            ></el-input>
          </div>
          <el-button
            type="primary"
            size="mini"
            class="search-btn fs14"
            @click="search"
            >{{
              $t("views.Analysisreport.channelPerfReport.51h4zb87em80")
            }}</el-button
          >
        </div> -->
      </div>
    </reportPageTemp>
  </div>
</template>
<script>
import reportPageTemp from "@/components/report/tableTemplate";
export default {
  name: "analysisreport-getCenterTrackMonth",
  data() {
    return {
      reportParams: {
        wayString: "getCenterTrackMonth", //传递到子组件的方法名称
        Title: "招生追踪月度统计表",
      },

      //筛选
      filter: {
        coursetype_id: "", //班组
        keyword: "",
      },
      // 筛选的下拉列表
      filterList: {
        coursetypeList: [], //班组-下拉数据
      },
      // 时间限制
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // }
      },
    };
  },
  components: {
    reportPageTemp,
  },
  created() {
    this.courseTypeRecruitApi();
  },
  mounted() {},
  methods: {
    //下拉列表->获取班组列表--zjb
    courseTypeRecruitApi() {
      this.$http.courseTypeRecruitApi({
        coursetype_isrecruit: 1
      }).then((res) => {
        if (res.data.code === 200) {
          this.filterList.coursetypeList = res.data.data.list;
        } else {
          this.filterList.coursetypeList = [];
        }
      });
    },
    //检索
    search() {
      this.$refs.reportPageTemp.search();
    },
  },
};
</script>
<style lang="less">
@import url("../../../assets/less/manage.less");
@import url("../analysisreport.less");
.getCenterTrackMonth {
  // height: 100vh;
  font-size: 20px;
}
</style>
